import { secondaryTabsByRole } from './roleTabs';

export function DesktopNav({ role, activeTab, onTabChange, labels, tabs }) {
  const tabList = tabs || [];
  if (!tabs.length) return null;

  return (
    <nav
      className="hidden border-b border-border bg-card/80 backdrop-blur-sm lg:block"
      aria-label="Section navigation"
    >
      <div className="mx-auto flex max-w-6xl gap-1 overflow-x-auto px-4 py-2">
        {tabList.map(({ id, labelKey, icon: Icon }) => {
          const active = activeTab === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onTabChange(id)}
              className={`flex min-h-touch shrink-0 items-center gap-2 rounded-lg px-4 py-2.5 text-sm font-medium transition-colors ${
                active
                  ? 'bg-primary-light text-primary'
                  : 'text-muted hover:bg-surface hover:text-text'
              }`}
            >
              <Icon className="h-4 w-4" strokeWidth={active ? 2.5 : 2} />
              <span>{labels[labelKey] || id}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
